function olo_authenticate_with_auth_token(auth_grant) {
  var $ = jQuery;
  ecw_show_loading();
  console.log('olo_sso_creds', auth_grant);
  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "punchh_olo_authenticate_app",
      auth_grant: auth_grant,
      referer: window.location.href,

    },
    success: function (response) {

      var result = JSON.parse(response);
      console.log('punchh_olo_authenticate response', result);

      if (result.code || result === 0) {
        if (result === 0) {
          alert("Something went wrong with the authentication. Please try signing in again.");
        } else {
          alert(result.code + (result.message ? `: ${result.message}` : ""));
        }
        // Remove auth_token from URL 
        let url = decodeURIComponent(window.location.href);
        // remove ?code=... 
        url = url.replace(/([?&])code=[^&]+/, '');
        // fix leftover ? or & 
        url = url.replace(/\?&/, '?').replace(/\?$/, ''); window.history.replaceState({}, '', url);
        ecw_hide_overloading();

      } else if (result.data.error) {
        // Remove auth_token from URL 
        let url = decodeURIComponent(window.location.href);
        // remove ?code=... 
        url = url.replace(/([?&])code=[^&]+/, '');
        // fix leftover ? or & 
        url = url.replace(/\?&/, '?').replace(/\?$/, ''); window.history.replaceState({}, '', url);
        
         alert('Error message: ' + result.data.error_description);
                 ecw_hide_overloading();

      }else {
        console.log('result.data.printedCardNumber', result.data.printedCardNumber);
        // $('.accountButton').removeClass("hide"); // $('.signInButton').addClass("hide"); 
        let url = decodeURIComponent(window.location.href);
        // remove ?code=... 
        url = url.replace(/([?&])code=[^&]+/, '');
        // fix leftover ? or & 
        url = url.replace(/\?&/, '?').replace(/\?$/, ''); window.history.replaceState({}, '', url);

        $.ajax({
          type: "POST",
          url: ajax_url,
          data: {
            action: "punchh_login_user",
            paytronixCardNumber: result.data.printedCardNumber
          },
          success: function (response) {
            console.log('response', response);
            // console.log(JSON.parse(response));
            var result = JSON.parse(response);

            // Check for errors
            if (result.status === "success") {
              punchh_olo_sso(result.data.access_token, result.data.refresh_token, false);
              // ecw_hide_loading();

            } else {
              alert('Please try again. Username or password is invalid.')

              ecw_hide_overloading(); 
            } 
          },
        }); 
      }



    },
    complete: function () {
      // location.reload();
      // console.log('ahhhh 1');
      // ecw_hide_overloading();


      isSubmitting = false;
      // ecw_hide_overloading();
    },
  });
}
//
function displaySignUpForm() {
  var $ = jQuery.noConflict();
  //show signup view
  if ($('.wf-ordering-login.not-in-order-flow').length) {
    change_view('signup');

    // view_signup();

  } else {
    orderSignup = true;
    // console.log('asdgasdgadsg', orderSignup)
    change_view('signup', noHashChange = true);
    view_signup(orderSignup);
  }

}

// View: Signup
function view_signup(orderSignup) {
  var $ = jQuery;
  $contentContainer
    .load(templateRoot + "wf-ordering-signup.html", function () {
      ecw_show_loading();
      window.scrollTo(0, 0);

      // console.log('view_signup');

      activateSignUp($contentContainer.find("#punchh-signup-form"));
      if (localStorage.getItem("ecw_customer_basket_id") && orderSignup) {
        // console.log('in order flow', orderSignup);
        $('.wf-ordering-container>.wf-ordering-signup.login-form.login-wrap').removeClass('not-in-order-flow');
      } else {
        // console.log('not in order flow', orderSignup);
        $('.wf-ordering-container>.wf-ordering-signup.login-form.login-wrap').addClass('not-in-order-flow');
      }
      $('#back-to-login').on('click', function () {
        if (orderSignup) {
          change_view('login');

          view_login(orderLogin);
        } else {
          change_view('login');
          view_login();
        }
        // console.log('i clikc');
      });
      ecw_hide_loading();
    })
    .hide()
    .fadeIn(transitionDuration);
}

// View: Login
function view_login(orderLogin) {
  var $ = jQuery;
  // console.log($contentContainer, templateRoot);
  if ($contentContainer.length === 0) {
    window.location.href = '/order/#login';
  }
  $contentContainer
    .load(templateRoot + "wf-ordering-login.html", function () {
      window.scrollTo(0, 0);
      // console.log('orderLogin', orderLogin);


      history.pushState(null, '', '/order/#login');

      let appCallOutClone = $('.app-callout.hide').clone();
      appCallOutClone.insertAfter('.app-callout-positioner');
      appCallOutClone.removeClass('hide');

      not_view_cart();

      activateSignIn($contentContainer.find("#punchh-login-form"));

      if (localStorage.getItem("ecw_customer_basket_id") && orderLogin) {
        $('.wf-ordering-container>.wf-ordering-login.login-form.login-wrap').removeClass('not-in-order-flow');
      } else {
        $('.wf-ordering-container>.wf-ordering-login.login-form.login-wrap').addClass('not-in-order-flow');
      }
      $('button#rewards-signup').off('click').on('click', function () {
        // view_cart();
        // console.log('i click');
        displaySignUpForm();
      });
      $('button#register-card-signup').off('click').on('click', function () {
        // view_cart();
        // console.log('i click');
        change_view('register-card');
      });
    })
    .hide()
    .fadeIn(transitionDuration);
}
//View register card
function view_register_card() {
  var $ = jQuery;
  $contentContainer
    .load(templateRoot + "wf-ordering-register-card.html", function () {
      window.scrollTo(0, 0);

      activateRegisterCard($contentContainer.find("#register-card-form"));

      // //
      $('#back-to-login').on('click', function () {
        // console.log('i clikc')
        orderLogin = true;
        view_login(orderLogin);
      });

    })
    .hide()
    .fadeIn(transitionDuration);
}
//View: Guest login 
function view_guest_login() {
  var $ = jQuery;
  $contentContainer
    .load(templateRoot + "wf-ordering-guest-checkout.html", function () {
      window.scrollTo(0, 0);
      var phonesMasks = [
        { mask: "(###) ###-####" },
      ];

      change_view('guest-checkout', noHashChange = true);

      //
      $('#back-to-login').on('click', function () {
        // console.log('i clikc')
        orderLogin = true;
        view_login(orderLogin);
      });
      // Guest Checkout User Info
      $("#guest-first-name").val(
        localStorage.getItem("ecw_customer_guest_first_name")
      );
      $("#guest-last-name").val(
        localStorage.getItem("ecw_customer_guest_last_name")
      );
      $("#guest-email-address").val(
        localStorage.getItem("ecw_customer_guest_email")
      );
      $("input#guest-phone-number").inputmask({
        mask: phonesMasks,
        greedy: false,
        definitions: { "#": { validator: "[0-9]", cardinality: 1 } },
      });

      $("#guest-phone-number").val(
        localStorage.getItem("ecw_customer_guest_phone_number")
      );

      $("#guest-signin-prompt form").submit(function (e) {
        // console.log('ahhh');
        e.preventDefault();
      });
      $(document).foundation();

      $("#guest-signin-prompt form").bind("formvalid.zf.abide", function (e, target) {
        // console.log('ahhh 2');

        e.preventDefault();
        localStorage.setItem(
          "ecw_customer_guest_first_name",
          $("#guest-first-name").val()
        );
        localStorage.setItem(
          "ecw_customer_guest_last_name",
          $("#guest-last-name").val()
        );
        localStorage.setItem(
          "ecw_customer_guest_email",
          $("#guest-email-address").val()
        );
        localStorage.setItem(
          "ecw_customer_guest_phone_number",
          $("#guest-phone-number").val()
        );

        change_view("checkout");
      });
    })
    .hide()
    .fadeIn(transitionDuration);
}
// Function to create signup form
function activateSignUp($formItem) {
  var $ = jQuery;
  ecw_show_loading();

  $("input#punchh_phone").inputmask({
    mask: phonesMasks,
    greedy: false,
    definitions: { "#": { validator: "[0-9]", cardinality: 1 } },
  });

  //restrict birthay 
  const punchhBirthdayInput = $('#punchh_birthday');
  const today = new Date();
  today.setDate(today.getDate() - 2);
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  const maxDateString = `${year}-${month}-${day}`;
  punchhBirthdayInput.attr('max', maxDateString);
  //end restrict birthay 

  $("#basketGuid").val(localStorage.getItem("ecw_customer_basket_id"));

  $('#punchh-signup-form').on('submit', function (e) {
    e.preventDefault(); // stop default form submission
    let headerHeight = $('header').outerHeight() || 0;

    const $form = $(this);
    const errors = [];

    const opt_in = $form.find('#punchh_opt-in').is(':checked') ? true : false;
    // console.log('opt_in', opt_in);
    const firstName = $form.find('input[name="first_name"]').val().trim();
    const lastName = $form.find('input[name="last_name"]').val().trim();
    const email = $form.find('input[name="email"]').val().trim();
    const username = $form.find('input[name="username"]').val().trim();
    const password = $form.find('input[name="password"]').val();
    const passwordConfirm = $form.find('input[name="password_confirm"]').val();
    const zip = $form.find('input[name="zip"]').val().trim();
    const phone = $form.find('input[name="phone"]').val().replace(/\D/g, "");
    // const favLocation = $form.find('select#location-dropdown').val();
    const birthday = punchhBirthdayInput.val();

    // Clear previous error messages
    $form.find('.form-error').hide();
    $('#form-errors').hide();

    // Email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      errors.push('email');
      $('#email-error').show();

      // $('html, body').animate({
      //   scrollTop: $('#email-error').offset().top - (headerHeight + headerHeight)
      // }, 500);
    }

    // Username validation (6-60 chars)
    const lettersOnly = /^[A-Za-z]+$/;
    if (
      username.length < 6 ||
      username.length > 60 ||
      !lettersOnly.test(username)
    ) {
      errors.push('username');
      $('#username-error').show();
    }

    // Password match
    if (password !== passwordConfirm) {
      errors.push('password_confirm');
      $('#password-confirm-error').show();
      // $('html, body').animate({
      //   scrollTop: $('#password-confirm-error').offset().top - (headerHeight + headerHeight)
      // }, 500);
    }

    // phone required
    // console.log('phone', phone);
    if (!phone || phone.length !== 10) {
      errors.push('phone');
      $('#phone-error').show();
      // $('html, body').animate({
      //   scrollTop: $('#phone-error').offset().top - (headerHeight + headerHeight)
      // }, 500);
    }
    if (birthday) {
      const birthdayDate = new Date(birthday);
      const now = new Date();

      // Validate date is valid
      if (isNaN(birthdayDate.getTime())) {
        errors.push('birthday');
        $('#birthday-error').show().text('Please enter a valid date.');
        // $('html, body').animate({
        //   scrollTop: $('#birthday-error').offset().top - (headerHeight * 2)
        // }, 500);
      } else {
        const birthYear = birthdayDate.getFullYear();

        if (birthYear < 1900) {
          errors.push('birthday');
          $('#birthday-error').show().text('Please enter a year after 1900.');
          // $('html, body').animate({
          //   scrollTop: $('#birthday-error').offset().top - (headerHeight * 2)
          // }, 500);
        } else if (birthdayDate >= now) {
          errors.push('birthday');
          $('#birthday-error').show().text('Birthday must be in the past.');
          // $('html, body').animate({
          //   scrollTop: $('#birthday-error').offset().top - (headerHeight * 2)
          // }, 500);
        } else {
          $('#birthday-error').hide();
        }
      }
    }

    if (errors.length > 0) {
      $('#form-errors').show().removeClass('hide');
      $('html, body').animate({
        scrollTop: $('#form-errors').offset().top - headerHeight
      }, 500);
      return false; // stop form submission
    } else {
      $('#form-errors').hide().addClass('hide');
    }

    // If valid, trigger your AJAX
    ecw_show_loading();
    // console.log('errors', errors);
    $.ajax({
      type: 'POST',
      url: ajax_url,
      data: {
        action: 'punchh_signup_user',
        opt_in: opt_in,
        first_name: firstName,
        last_name: lastName,
        email: email,
        username: username,
        password: password,
        zip: zip,
        phone: phone,
        // favLocation: favLocation,
        birthday: (function () {
          const val = punchhBirthdayInput.val();
          if (!val) return '';
          const parts = val.split('/');
          if (parts.length !== 3) return val;
          return parts[2] + '-' + parts[0].padStart(2, '0') + '-' + parts[1].padStart(2, '0');
        })()
      },
      success: function (response) {

        ecw_show_loading();

        let result = typeof response === 'string' ? JSON.parse(response) : response;
        console.log('punchh_signup_user', result);
        const cardNumber = result.data ? result.data.printedCardNumber : undefined;
        // console.log('cardNumber', cardNumber);

        if (result.data) {
          let formErrors = {};
          let errorMessages = [];
          if (result.data.result === 'invalidInputs' && result.data.errorsByField) {
            // Transform errorsByField to match ecw_set_form_errors format
            Object.keys(result.data.errorsByField).forEach(function (fieldKey) {
              let fieldName = fieldKey.split('/').pop(); // e.g., "username"
              let messages = result.data.errorsByField[fieldKey];
              formErrors[fieldName] = messages;
              messages.forEach(msg => errorMessages.push(`${fieldName}: ${msg}`));
            });

            // Show field-level errors
            $('#form-errors')
              .removeClass('hide')
              .css('display', 'block')
              .html(result.data.errorMessage + ':<br>' + errorMessages.join('<br>'));

            // console.log('formErrors', formErrors);
            $('html, body').animate({
              scrollTop: $('#form-errors').offset().top - headerHeight
            }, 500);
            ecw_set_form_errors(formErrors, $form);
            ecw_hide_loading();

          } else if (result.data.result === 'uniquenessConflict') {
            $('#form-errors')
              .removeClass('hide')
              .css('display', 'block')
              .text(result.data.errorMessage || 'The phone number, email address, or username already exists. Do you already have an account?');
            $('html, body').animate({
              scrollTop: $('#form-errors').offset().top - headerHeight
            }, 500);
            console.error('General error:', result.data.errorMessage || result.data);
            ecw_hide_loading();
          } else if (result.data.result === 'failed' || result.data.errorMessage) {
            // Handle general/system errors
            $('#form-errors')
              .removeClass('hide')
              .css('display', 'block')
              .text(result.data.errorMessage || 'Something went wrong. Please try again.');
            $('html, body').animate({
              scrollTop: $('#form-errors').offset().top - headerHeight
            }, 500);
            console.error('General error:', result.data.errorMessage || result.data);
            ecw_hide_loading();

          } else {
            console.log('email', email, 'username', username, 'password', password, 'cardNumber', cardNumber);
            ecw_show_loading();
            $.ajax({
              type: "POST",
              url: ajax_url,
              data: {
                action: "punchh_login_user",
                paytronixCardNumber: cardNumber
              },
              success: function (response) {
                console.log('punchh_login_user', response);
                // console.log(JSON.parse(response));
                var result = JSON.parse(response);

                // Check for errors
                if (result.status === "success") {
                  punchh_olo_sso(result.data.access_token, result.data.refresh_token, false);
                  // ecw_hide_loading();
                  // change_view('menu');

                } else {
                  // errors found
                  var formerrors = {};

                  if (result.data !== null && result.data.result === "noMatchingGuests") {
                    formerrors = {
                      base: "Please try again. Username or password is invalid.",
                    };
                  } else {
                    formerrors = {
                      base: "Please try again. Username or password is invalid.",
                    };
                  }
                  isSubmitting = false;

                  ecw_set_form_errors(formerrors, $("#punchh-login-form"));
                  ecw_hide_loading();
                }
              },
            });
            // ecw_hide_loading();
            // orderLogin = true;
            // view_login(orderLogin);
            // window.history.replaceState(null, "", "/order/#login");
            // location.reload();
          }
        }


      }
    });
  });

}

function activateRegisterCard() {
  var $ = jQuery;
  $("#basketGuid").val(localStorage.getItem("ecw_customer_basket_id"));

  $('#register-card-form').on('submit', function (e) {
    // ecw_show_loading();

    // console.log('i submit?');
    $("input#punchh_phone").inputmask({
      mask: phonesMasks,
      greedy: false,
      definitions: { "#": { validator: "[0-9]", cardinality: 1 } },
    });
    e.preventDefault(); // stop default form submission
    let headerHeight = $('header').outerHeight() || 0;

    const $form = $(this);
    const errors = [];

    const cardNumber = $form.find('input#card_number').val().trim();
    const opt_in = $form.find('#punchh_opt-in').is(':checked') ? true : false;
    // console.log('opt_in', opt_in);
    const firstName = $form.find('input[name="first_name"]').val().trim();
    const lastName = $form.find('input[name="last_name"]').val().trim();
    const email = $form.find('input[name="email"]').val().trim();
    const username = $form.find('input[name="username"]').val().trim();
    const password = $form.find('input[name="password"]').val();
    const passwordConfirm = $form.find('input[name="password_confirm"]').val();
    // const favLocation = $form.find('select#location-dropdown').val();

    // Clear previous error messages
    $form.find('.form-error').hide();
    $('#form-errors').hide();
    // First name required
    if (!firstName) {
      errors.push('first_name');
      $('#punchh_first_name').next('.form-error').show();

      // $('html, body').animate({
      //   scrollTop: $('#punchh_first_name').offset().top - (headerHeight * 2)
      // }, 500);
    }

    // Last name required
    if (!lastName) {
      errors.push('last_name');
      $('#punchh_last_name').next('.form-error').show();

      // $('html, body').animate({
      //   scrollTop: $('#punchh_last_name').offset().top - (headerHeight * 2)
      // }, 500);
    }
    // card validation
    const cardNumberPattern = /^[0-9]+$/;

    if (!cardNumberPattern.test(cardNumber)) {
      errors.push('cardNumber');
      $('#card_number_error').show();

      // $('html, body').animate({
      //   scrollTop: $('#card_number_error').offset().top - (headerHeight + headerHeight)
      // }, 500);
    }
    // Email validation
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      // console.log('email error');
      errors.push('email');
      $('#email-error').show();

      // $('html, body').animate({
      //   scrollTop: $('#email-error').offset().top - (headerHeight + headerHeight)
      // }, 500);
    }

    // Username validation (6-60 chars)
    const lettersOnly = /^[A-Za-z]+$/;
    if (
      username.length < 6 ||
      username.length > 60 ||
      !lettersOnly.test(username)
    ) {
      errors.push('username');
      $('#username-error').show();
    }

    // Password match
    if (password !== passwordConfirm) {
      errors.push('password_confirm');
      $('#password-confirm-error').show();
      // $('html, body').animate({
      //   scrollTop: $('#password-confirm-error').offset().top - (headerHeight + headerHeight)
      // }, 500);
    }


    if (errors.length > 0) {
      $('#form-errors').show().removeClass('hide');
      $('html, body').animate({
        scrollTop: $('#form-errors').offset().top - headerHeight
      }, 500);
      return false; // stop form submission
    } else {
      $('#form-errors').hide().addClass('hide');

    }

    // If valid, trigger your AJAX
    ecw_show_loading();
    $.ajax({
      type: 'POST',
      url: ajax_url,
      data: {
        action: 'punchh_register_card',
        cardNumber: cardNumber,
        opt_in: opt_in,
        first_name: firstName,
        last_name: lastName,
        email: email,
        username: username,
        password: password
      },
      success: function (response) {
        // console.log('username', username, 'password', password);
        // console.log('punchh_register_card', response);
        ecw_show_loading();

        let result = typeof response === 'string' ? JSON.parse(response) : response;
        // console.log('punchh_register_card result', result);

        if (result.data) {
          let formErrors = {};
          let errorMessages = [];
          if (result.data.result === 'invalidInputs' && result.data.errorsByField) {

            console.log('result.data.errorsByField', result.data.errorsByField);
            // Transform errorsByField to match ecw_set_form_errors format
            Object.keys(result.data.errorsByField).forEach(function (fieldKey) {
              let fieldName = fieldKey.split('/').pop(); // e.g., "username"
              let messages = result.data.errorsByField[fieldKey];

              // Save the messages array to formErrors if you still need it
              formErrors[fieldName] = messages;

              // Push the text of each error, not the object
              messages.forEach(msg => {
                errorMessages.push(`${fieldName}: ${msg.text}`);
              });
            });

            // Show field-level errors
            console.log('result.data.errorsByField', result.data.errorsByField);
            $('#form-errors')
              .removeClass('hide')
              .css('display', 'block')
              .html(result.data.errorMessage + ':<br>' + errorMessages.join('<br>'));

            // console.log('formErrors', formErrors);
            $('html, body').animate({
              scrollTop: $('#form-errors').offset().top - headerHeight
            }, 500);
            ecw_set_form_errors(formErrors, $form);
            ecw_hide_loading();

          } else if (result.data.result === 'uniquenessConflict') {
            $('#form-errors')
              .removeClass('hide')
              .css('display', 'block')
              .text(result.data.errorMessage || 'The phone number, email address, or username already exists. Do you already have an account?');
            $('html, body').animate({
              scrollTop: $('#form-errors').offset().top - headerHeight
            }, 500);
            console.error('General error:', result.data.errorMessage || result.data);
            ecw_hide_loading();
          } else if (result.data.result === 'failed' || result.data.errorMessage) {
            // Handle general/system errors
            $('#form-errors')
              .removeClass('hide')
              .css('display', 'block')
              .text(result.data.errorMessage || 'Something went wrong. Please try again.');
            $('html, body').animate({
              scrollTop: $('#form-errors').offset().top - headerHeight
            }, 500);
            console.error('General error:', result.data.errorMessage || result.data);
            ecw_hide_loading();

          } else {
            // orderLogin = true; 
            // view_login(orderLogin);
            // window.history.replaceState(null, "", "/order/#login");
            // location.reload();
            $.ajax({
              type: "POST",
              url: ajax_url,
              data: {
                action: "punchh_login_user",
                paytronixCardNumber: cardNumber
              },
              success: function (response) {
                // console.log('response', response);
                // console.log(JSON.parse(response));
                var result = JSON.parse(response);

                // Check for errors
                if (result.status === "success") {
                  punchh_olo_sso(result.data.access_token, result.data.refresh_token, false);
                  // ecw_hide_loading();

                } else {
                  // errors found
                  var formerrors = {};

                  if (result.data !== null && result.data.result === "noMatchingGuests") {
                    formerrors = {
                      base: "Please try again. Username or password is invalid.",
                    };
                  } else {
                    formerrors = {
                      base: "Please try again. Username or password is invalid.",
                    };
                  }
                  isSubmitting = false;

                  ecw_set_form_errors(formerrors, $("#punchh-login-form"));
                  ecw_hide_loading();
                }
              },
            });
          }
        }

      }
    });

  });

}

//function to create login form
function activateSignIn($formItem) {
  var $ = jQuery;

  var loginFormAbide = new Foundation.Abide($formItem, {});

  // console.log($formItem.length);

  $("#basketGuid").val(localStorage.getItem("ecw_customer_basket_id"));

  let isSubmitting = false;

  $formItem.on("submit", function (e) {
    // console.log('submit sign up form', isSubmitting); 

    e.preventDefault();
    // isSubmitting = true;
  });
  $formItem.on("formvalid.zf.abide", function (e, target) {

    e.preventDefault(); // prevent native submit
    if (isSubmitting) return; // block duplicate
    isSubmitting = true;

    ecw_show_loading();
    localStorage.setItem('ecw_customer_username', $("#punchh-login-form").find('input#punchh_username').val());


    $.ajax({
      type: "POST",
      url: ajax_url,
      data: {
        action: "authenicate_punchh_user",
        // email: $("#punchh-login-form").find('input[name="email"]').val(),
        username: $("#punchh-login-form").find('input[name="username"]').val(),
        password: $("#punchh-login-form")
          .find('input[name="password"]')
          .val(),
        // recaptcha: $("#g-recaptcha-response").val(),
      },
      success: function (response) {
        // console.log($("#g-recaptcha-response").val());

        // console.log($("#punchh-login-form").find('input[name="username"]').val(), $("#punchh-login-form")
        //   .find('input[name="password"]')
        //   .val());
        // console.log('authenicate_punchh_user', JSON.parse(response));
        var result = JSON.parse(response);
        // Check for errors
        if (result.status === "success") {
          let paytronixCardNumber = result.data.primaryPrintedCardNumber;
          console.log('paytronixCardNumber', paytronixCardNumber);
          $.ajax({
            type: "POST",
            url: ajax_url,
            data: {
              action: "punchh_login_user",
              paytronixCardNumber: paytronixCardNumber
            },
            success: function (response) {
              // console.log('response', response);
              // console.log(JSON.parse(response));
              var result = JSON.parse(response);

              // Check for errors
              if (result.status === "success") {
                punchh_olo_sso(result.data.access_token, result.data.refresh_token, false);
              } else {
                // errors found
                var formerrors = {};

                if (result.data !== null && result.data.result === "noMatchingGuests") {
                  formerrors = {
                    base: "Please try again. Username or password is invalid.",
                  };
                } else {
                  formerrors = {
                    base: "Please try again. Username or password is invalid.",
                  };
                }
                isSubmitting = false;

                ecw_set_form_errors(formerrors, $("#punchh-login-form"));
                ecw_hide_loading();
              }
            },
          });
        } else {
          console.error('authenicate_punchh_user', response);
          // errors found
          var formerrors = {};

          if (result.data !== null && result.data.result === "noMatchingGuests") {
            formerrors = {
              base: "Please try again. Username or password is invalid.",
            };
          } else {
            formerrors = {
              base: "Something went wrong. Please try again.",
            };
          }
          isSubmitting = false;

          ecw_set_form_errors(formerrors, $("#punchh-login-form"));
          ecw_hide_loading();
        }
      },
    });
  });
}
// // View: Forgot Password
// function view_forgotpassword() {
//   var $ = jQuery;
//   $contentContainer
//     .load(templateRoot + "wf-ordering-forgotpassword.html", function () {
//       activateForgotPassword(
//         $contentContainer.find("#punchh-forgotpassword-form")
//       );
//     })
//     .hide()
//     .fadeIn(transitionDuration);
// }

// // Function to create forgot password form
// function activateForgotPassword($formItem) {
//   var $ = jQuery;

//   var forgotPasswordFormAbide = new Foundation.Abide($formItem, {});

//   $formItem.on("submit", function (e) {
//     e.preventDefault();
//   });
//   $formItem.on("formvalid.zf.abide", function (e, target) {
//     // alert('valid');
//     ecw_show_loading();
//     $.ajax({
//       type: "POST",
//       url: ajax_url,
//       data: {
//         action: "punchh_forgotpassword_user",
//         email: $formItem.find('input[name="email"]').val(),
//       },
//       success: function (response) {
//         // console.log(response);
//         // console.log(JSON.parse(response));
//         // var result = JSON.parse(response);

//         $("[data-abide-success]").show();
//         $("[data-abide-error]").hide();

//         ecw_hide_loading();
//       },
//     });
//   });
// }
// View: Signout
function view_signout() {
  signout();
  change_view("login");
}

function signout(shouldClearBasket = true) {
  var $ = jQuery;
  // console.log('i sign out', shouldClearBasket);
  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_delete_user_authtoken",
      authtoken: localStorage.getItem("ecw_auth_token"),
      referer: window.location.href

    },
    success: function (response) {

    },
  });

  // Remove Access Elements
  localStorage.removeItem("ecw_access_token");
  localStorage.removeItem("ecw_user_id");
  localStorage.removeItem("ecw_auth_token");
  localStorage.removeItem("ecw_customer_membership_id");
  localStorage.removeItem("ecw_customer_signed_in");
  localStorage.removeItem("ecw_customer_host_group_order_name");
  localStorage.removeItem("ecw_customer_group_order_user_type");
  localStorage.removeItem("ecw_customer_group_order_deadline");
  localStorage.removeItem('ecw_customer_group_order_name');

  if (shouldClearBasket) {
    clearBasketSession();
    change_view("login");
  }
  $('.accountButton').addClass("hide");
  $('.signInButton').removeClass("hide");
}